import type { ReactNode } from 'react'

import clsx from 'clsx'

import { SearchInput } from '@/shared/ui/Form/SearchInput'

type ResourceFilterBarProps = {
  searchValue: string
  onSearchChange: (value: string) => void
  onSearchSubmit?: () => void
  searchPlaceholder?: string
  searchAriaLabel?: string
  advancedFilter?: ReactNode
  className?: string
}

/**
 * Linha canônica de filtros de listagem — busca textual + slot do filtro avançado.
 * Usado em programação, parceiros e demais recursos com filtro elaborado em sheet.
 */
export const ResourceFilterBar = ({
  searchValue,
  onSearchChange,
  onSearchSubmit,
  searchPlaceholder,
  searchAriaLabel,
  advancedFilter,
  className
}: ResourceFilterBarProps) => (
  <div className={clsx('flex min-w-0 items-center gap-2', className)}>
    <SearchInput
      value={searchValue}
      onChange={event => onSearchChange(event.target.value)}
      onKeyDown={event => {
        if (event.key !== 'Enter') return
        event.preventDefault()
        onSearchSubmit?.()
      }}
      placeholder={searchPlaceholder}
      aria-label={searchAriaLabel ?? searchPlaceholder}
      containerClassName="min-w-0 flex-1"
    />
    {advancedFilter}
  </div>
)

ResourceFilterBar.displayName = 'ResourceFilterBar'
